import axios from "axios";

const instance = axios.create({
  baseURL: 'https://avatar-generator-b313c-default-rtdb.europe-west1.firebasedatabase.app/'
});

export default instance;